import { PRODUCTION, DEVELOPMENT, API_DEV_URL } from "./const";
import { isEmpty } from "lodash";

export function baseUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const API_URL = !!process.env.REACT_APP_INTEL_API_URL && process.env.REACT_APP_INTEL_API_URL !== "" ? process.env.REACT_APP_INTEL_API_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return API_DEV_URL;
      case PRODUCTION:
        return API_URL;
      default:
        return API_DEV_URL;
    }
  } else {
    return API_DEV_URL;
  }
}

export const getApiUrl = (path) => {
  return `${baseUrl()}/${path}`;
};
